var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 32C2.16667 32 1.45833 31.7083 0.875 31.125C0.291667 30.5417 0 29.8333 0 29V6H3V29H38V32H3ZM9 26C8.16667 26 7.45833 25.7083 6.875 25.125C6.29167 24.5417 6 23.8333 6 23V3C6 2.16667 6.29167 1.45833 6.875 0.875C7.45833 0.291667 8.16667 0 9 0H41C41.8333 0 42.5417 0.291667 43.125 0.875C43.7083 1.45833 44 2.16667 44 3V23C44 23.8333 43.7083 24.5417 43.125 25.125C42.5417 25.7083 41.8333 26 41 26H9ZM9 23H14C14 21.6 13.5167 20.4167 12.55 19.45C11.5833 18.4833 10.4 18 9 18V23ZM36 23H41V18C39.6 18 38.4167 18.4833 37.45 19.45C36.4833 20.4167 36 21.6 36 23ZM25 19C26.6667 19 28.0833 18.4167 29.25 17.25C30.4167 16.0833 31 14.6667 31 13C31 11.3333 30.4167 9.91667 29.25 8.75C28.0833 7.58333 26.6667 7 25 7C23.3333 7 21.9167 7.58333 20.75 8.75C19.5833 9.91667 19 11.3333 19 13C19 14.6667 19.5833 16.0833 20.75 17.25C21.9167 18.4167 23.3333 19 25 19ZM9 8C10.4 8 11.5833 7.51667 12.55 6.55C13.5167 5.58333 14 4.4 14 3H9V8ZM41 8V3H36C36 4.4 36.4833 5.58333 37.45 6.55C38.4167 7.51667 39.6 8 41 8Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVExpense);
export default __webpack_public_path__ + "static/media/vExpense.1bdfb96e8c9d4b031ce0d206466b234e.svg";
export { ForwardRef as ReactComponent };